import { FunctionComponent, SVGProps } from 'react'

export type SVGType = FunctionComponent<SVGProps<SVGSVGElement> & { title?: string | undefined }>
